import React from 'react';

// Simple text-based company logo until we can properly integrate the image
const LogoCompany = ({ size = 32 }) => (
  <div style={{
    fontSize: size * 0.6,
    fontWeight: 'bold',
    color: '#FF4757',
    fontFamily: 'Arial, sans-serif',
    letterSpacing: '-1px'
  }}>
    7pay
  </div>
);

export default LogoCompany;
